var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 6.98098C1.66675 6.68905 1.66675 6.54308 1.67893 6.42014C1.79642 5.23435 2.73447 4.29629 3.92026 4.17881C4.0432 4.16663 4.19705 4.16663 4.50473 4.16663C4.62329 4.16663 4.68257 4.16663 4.7329 4.16358C5.37559 4.12465 5.93837 3.71902 6.17854 3.12162C6.19734 3.07484 6.21492 3.0221 6.25008 2.91663C6.28524 2.81115 6.30282 2.75841 6.32163 2.71163C6.56179 2.11423 7.12457 1.7086 7.76726 1.66967C7.81759 1.66663 7.87318 1.66663 7.98436 1.66663H12.0158C12.127 1.66663 12.1826 1.66663 12.2329 1.66967C12.8756 1.7086 13.4384 2.11423 13.6785 2.71163C13.6973 2.75841 13.7149 2.81115 13.7501 2.91663C13.7852 3.0221 13.8028 3.07484 13.8216 3.12162C14.0618 3.71902 14.6246 4.12465 15.2673 4.16358C15.3176 4.16663 15.3769 4.16663 15.4954 4.16663C15.8031 4.16663 15.957 4.16663 16.0799 4.17881C17.2657 4.29629 18.2037 5.23435 18.3212 6.42014C18.3334 6.54308 18.3334 6.68905 18.3334 6.98098V13.5C18.3334 14.9001 18.3334 15.6002 18.0609 16.1349C17.8212 16.6053 17.4388 16.9878 16.9684 17.2275C16.4336 17.5 15.7335 17.5 14.3334 17.5H5.66675C4.26662 17.5 3.56655 17.5 3.03177 17.2275C2.56137 16.9878 2.17892 16.6053 1.93923 16.1349C1.66675 15.6002 1.66675 14.9001 1.66675 13.5V6.98098Z",
    stroke: "#5466F9",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 13.75C11.841 13.75 13.3334 12.2576 13.3334 10.4166C13.3334 8.57568 11.841 7.08329 10.0001 7.08329C8.15913 7.08329 6.66675 8.57568 6.66675 10.4166C6.66675 12.2576 8.15913 13.75 10.0001 13.75Z",
    stroke: "#5466F9",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.192ed4ec.svg";
export { ForwardRef as ReactComponent };